import { t } from "@/i18n-js/instance";

interface RecordingDurationProps {
  recording_duration: string;
}

export const RecordingDuration = ({
  recording_duration,
}: RecordingDurationProps) => (
  <div className="mb-6">
    <div className="text-darkest font-medium">
      {t("live_streams.dashboard.details.duration")}
    </div>
    <p>{recording_duration}</p>
  </div>
);
